export enum TenancyAgreementGuarantorSigningOptions {
    NOT_REQUIRED = 0,
    SIGN_TENANCY_AGREEMENT = 1,
    SIGN_ALTERNATIVE = 2
}
export const ReverseTenantAgreementGuarantorSigningOptions = {
    [TenancyAgreementGuarantorSigningOptions.NOT_REQUIRED]: 'Not required / Handled externally',
    [TenancyAgreementGuarantorSigningOptions.SIGN_TENANCY_AGREEMENT]: 'Sign tenancy agreement',
    [TenancyAgreementGuarantorSigningOptions.SIGN_ALTERNATIVE]: 'Sign alternative'
}
